module.exports = __webpack_public_path__ + "static/media/warehouse.d57fe6fb.svg";